import { RootState, TaxCategoriesStateType } from '@types'
import { createSelector } from 'reselect'

const stateSelector = (state: RootState): TaxCategoriesStateType =>
  state.TaxCategories

export const selectTaxCategories = createSelector(stateSelector, (categories) =>
  Object.values(categories),
)
